"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveUpdatesManager = void 0;
var react_1 = __importDefault(require("react"));
var react_dependency_injection_1 = require("@meraki-internal/react-dependency-injection");
var react_2 = require("@ionic/react");
var state_1 = require("@meraki-internal/state");
var dayjs_1 = __importDefault(require("dayjs"));
var LiveUpdatesService_1 = require("./LiveUpdatesService");
var react_3 = require("react");
var DelayLiveUpdateInstallService_1 = require("./DelayLiveUpdateInstallService");
var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
dayjs_1.default.extend(relativeTime_1.default);
var Field = function (_a) {
    var label = _a.label, value = _a.value, children = _a.children;
    return (react_1.default.createElement("div", null,
        label,
        ":",
        react_1.default.createElement("div", { style: { fontSize: '.8em', margin: 10, color: 'grey' } },
            react_1.default.createElement("div", null, value),
            children)));
};
var SmartButton = function (_a) {
    var onClick = _a.onClick, children = _a.children, disabled = _a.disabled;
    var alert = (0, react_2.useIonAlert)()[0];
    var _b = (0, react_3.useState)(false), isInvoking = _b[0], setIsInvoking = _b[1];
    var smartOnClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setIsInvoking(true);
                    return [4 /*yield*/, onClick()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    alert(err_1.toString());
                    return [3 /*break*/, 3];
                case 3:
                    setIsInvoking(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var smartDisabled = isInvoking || disabled;
    return (react_1.default.createElement(react_2.IonButton, { disabled: smartDisabled, onClick: smartOnClick }, children));
};
var LiveUpdatesManager = function () {
    var _a, _b, _c;
    var liveUpdatesService = (0, react_dependency_injection_1.useInstance)(LiveUpdatesService_1.LiveUpdatesService);
    var config = (0, react_dependency_injection_1.useInstance)(LiveUpdatesService_1.LiveUpdatesServiceConfig);
    (0, state_1.useSubscription)(function () { return liveUpdatesService; });
    var shaProvider = (0, react_dependency_injection_1.useInstance)(LiveUpdatesService_1.ActualSHAProvider);
    var delayLiveUpdateService = (0, react_dependency_injection_1.useInstance)(DelayLiveUpdateInstallService_1.DelayLiveUpdateInstallService);
    var isDevServer = config.isDevServer;
    var installedSha = shaProvider.getSHA();
    var installedLiveUpdateVersion = (((_a = liveUpdatesService.getCurrentBundle()) === null || _a === void 0 ? void 0 : _a.version) || 'native') + (isDevServer ? ' (overridden by dev server)' : '');
    // disabling install when running locally b/c it is not intuitive
    // it DOES install the bundle (so can test all that, but it DOES NOT change out the web view)
    var canInstall = !isDevServer && liveUpdatesService.getLiveUpdateStatus() === 'downloaded';
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, "Live Updates Manager"),
        react_1.default.createElement("h2", null, liveUpdatesService.getLiveUpdateStatus()),
        react_1.default.createElement(Field, { label: "Native Version", value: liveUpdatesService.getNativeVersion() || '' }),
        react_1.default.createElement(Field, { label: "Installed SHA", value: installedSha }),
        react_1.default.createElement(Field, { label: "Installed Live Update Version", value: installedLiveUpdateVersion }),
        react_1.default.createElement(Field, { label: "Available Live Update Version", value: (((_b = liveUpdatesService.latestVersionAvailable) === null || _b === void 0 ? void 0 : _b.version) || '') + (liveUpdatesService.getLiveUpdateStatus() === 'up-to-date' ? ' (up to date)' : '') },
            react_1.default.createElement(react_1.default.Fragment, null,
                liveUpdatesService.getLiveUpdateStatus() !== 'up-to-date' && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(SmartButton, { disabled: liveUpdatesService.getLiveUpdateStatus() !== 'live-update-available', onClick: liveUpdatesService.downloadLatest }, "Download"),
                    react_1.default.createElement(SmartButton, { disabled: !canInstall, onClick: liveUpdatesService.installLatest }, "Install"))),
                liveUpdatesService.getLiveUpdateStatus() === 'downloaded' && (react_1.default.createElement(react_1.default.Fragment, null,
                    delayLiveUpdateService.getCanInstallOnForegroundAfter() && (react_1.default.createElement(react_1.default.Fragment, null,
                        delayLiveUpdateService.getCanInstallOnForegroundAfter() < new Date().toISOString() && (react_1.default.createElement("div", null, "Auto Install on Next Foreground")),
                        delayLiveUpdateService.getCanInstallOnForegroundAfter() > new Date().toISOString() && (react_1.default.createElement("div", null,
                            "Auto Install on Foreground after ",
                            (0, dayjs_1.default)(delayLiveUpdateService.getCanInstallOnForegroundAfter()).format('hh:mm a'))))),
                    delayLiveUpdateService.getCanInstallOnHashChangeAfter() && (react_1.default.createElement(react_1.default.Fragment, null,
                        delayLiveUpdateService.getCanInstallOnHashChangeAfter() < new Date().toISOString() && (react_1.default.createElement("div", null, "Auto Install on Next Hash Change")),
                        delayLiveUpdateService.getCanInstallOnHashChangeAfter() > new Date().toISOString() && (react_1.default.createElement("div", null,
                            "Auto Install on Hash Change after ",
                            (0, dayjs_1.default)(delayLiveUpdateService.getCanInstallOnHashChangeAfter()).format('hh:mm a'))))))),
                react_1.default.createElement("div", null, liveUpdatesService.getAvailableLiveUpdateUrl()),
                ((_c = liveUpdatesService.latestVersionAvailable) === null || _c === void 0 ? void 0 : _c.asOf) && (react_1.default.createElement("div", null,
                    "As of",
                    liveUpdatesService.latestVersionAvailable.asOf,
                    " ",
                    (0, dayjs_1.default)(liveUpdatesService.latestVersionAvailable.asOf).fromNow())),
                react_1.default.createElement(SmartButton, { onClick: liveUpdatesService.refreshLatestAvailableLiveUpdate }, "Refresh"))),
        react_1.default.createElement(Field, { label: "Last Installed Live Update Version", value: liveUpdatesService.lastInstalledLiveUpdateVersion || '(none)' }),
        react_1.default.createElement("div", null,
            "Bundles",
            react_1.default.createElement("ul", { style: { margin: 0, padding: 15 } }, (liveUpdatesService.bundles || []).map(function (bundle) { return (react_1.default.createElement("li", { key: bundle.id },
                react_1.default.createElement("div", null,
                    bundle.version,
                    react_1.default.createElement("span", { style: { color: 'grey', marginLeft: 10 } }, bundle.status),
                    react_1.default.createElement("span", { style: { color: 'grey', marginLeft: 10, display: 'block' } },
                        "Downloaded ",
                        (0, dayjs_1.default)(bundle.downloaded).fromNow()),
                    react_1.default.createElement(SmartButton, { disabled: !liveUpdatesService.canDeleteBundle(bundle), onClick: function () { return liveUpdatesService.deleteBundle(bundle); } }, "Delete")))); })))));
};
exports.LiveUpdatesManager = LiveUpdatesManager;
//# sourceMappingURL=LiveUpdatesManager.js.map